module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av226-b6aa64f379d1cb4481248281f6d70bc7.jpg";